import Routers from "./routers/Router";
import "./styles/global.css";

function App() {
  return (
    <Routers />
  );
}

export default App;
